export default "__VITE_ASSET__By8sktuM__"